import { APIURL } from '../../constants';
import axios from 'axios';
import { plotDistances, setRoute } from '../../tools/';

export default {
  namespaced: true,
  state: {
    lines: [],
    closestLines: {},
    leafletLines: {},
    guideLayer: {}, // used for snapping the marker to route polyline,
    attachMarkerToNode: true,
    redrawnLines: [],
    drawLineAutomatically: true
  },

  actions: {
    /*getRouteLength(context)
		{
			let route = context.rootGetters['routes/route'];
			if(typeof route !== 'undefined')
			{
				context.dispatch('lines')
				.then((lines) => {
					let 
				})
			}
		},*/

    updateGuideLayer(context) {
      let markers = context.rootGetters['locations/leafletMarkers'];

      context.commit('updateGuideLayer', markers);
    },

    updateLinesPosAfterMarkerRemove(context, payload) {
      context.commit('updateLinesPosAfterMarkerRemove', payload);
      context.dispatch('updateGuideLayer');
    },

    closestLines(context, payload) {
      //console.log("payload", payload)
      let closestLines = {};

      context.state.lines.forEach(l => {
        closestLines[l.leafletid] = [];
        l.points.forEach((p, pi) => {
          let d = plotDistances(
            p.lat,
            p.lng,
            payload._latlng.lat,
            payload._latlng.lng,
            l
          );

          if (d.distance < 5) {
            closestLines[l.leafletid].push(pi);
          }
        });
      });

      context.commit('setClosestLines', closestLines);
      return Promise.resolve(true);
    },

    mapLinesToPolylines(context, payload) {
      let ids = Object.keys(payload).map(id => {
        return id;
      });

      let lines = [];

      ids.forEach(id => {
        let line = context.state.lines.find(l => {
          return l._id == id;
        });

        if (line) {
          line.leafletid = payload[id];
          //line.leafletlayer = payload[id].leafletlayer
          lines.push(line);
        }
      });

      context.commit('mapLinesToPolylines', lines);
    },

    /*destroy(context, payload)
		{
			console.log("###### payload", payload)

			let hardDelete = false;
			if(window.localStorage.getItem('onlyHidden') == 1)
			{
				hardDelete = true;
			}
			
			let leafletIds = Object.keys(payload._layers).map((id) => {
				return id;
			})
			let hide = []
			let remove = []
		
			//console.log("################ state.lines", context.state.lines)
			leafletIds.forEach((id) => {

				let line = context.state.lines.find((l) => {
					
					return l.leafletid == id;
				})

				
				if(line)
				{
					if(line.properties.removed === true)
					{
						remove.push(line)
					} else {
						hide.push(line);
					}
				}

				//console.log("######### line", line)

			})

			//console.log("########## lines", lines)

			if(remove.length > 0 || hide.length > 0)
			{
				return axios.post(`${APIURL}routelines/bulkDestroy`, hide).then(() => {
					return axios.post(`${APIURL}routelines/bulkDestroy?hard=1`, remove)
				}).catch((hideErr) => {
					return axios.post(`${APIURL}routelines/bulkDestroy?hard=1`, remove)
				})
				
			}
		},*/

    destroy(context, payload) {
      let leafletIds = Object.keys(payload._layers).map(id => {
        return id;
      });
      let lines = [];
      leafletIds.forEach(id => {
        let line = context.state.lines.find(l => {
          return l.leafletid == id;
        });

        if (line) {
          lines.push(line._id);
        }
      });

      if (lines.length > 0) {
        axios
          .post(APIURL + 'routelines/bulkDestroy?hard=1', lines)
          .then(() => {
            //console.log("res", res.data)
          })
          .catch(() => {
            //console.log(err)
          });
      }
    },

    updateLinesAfterLatLngUpdate(context, payload) {
      let updated = payload
        .map(p => {
          let found = context.state.lines.find(l => {
            return l.leafletid == p._leaflet_id;
          });

          return { ...p, _id: found._id };
        })
        .filter(u => {
          return typeof u !== 'undefined';
        });

      updated = updated.map(u => {
        let coordinates = u._latlngs.map(latlng => {
          let c = [];
          c[0] = latlng.lng;
          c[1] = latlng.lat;

          return c;
        });

        return { _id: u._id, geometry: { coordinates, type: 'LineString' } };
      });

      //onsole.log('updated###############', updated);
      return axios
        .put(APIURL + 'routelines/update', updated)
        .then(() => {
          return Promise.resolve(true);
        })
        .catch(err => {
          return Promise.reject(err);
        });
    },

    updateMovedLines(context, payload) {
      let updated = [];
      let layers = Object.keys(payload.edited._layers).map(id => {
        return id;
      });

      let redrawnLines = context.state.redrawnLines.map(rdl => {
        payload.edited._layers[rdl._leaflet_id] = rdl;
        return rdl._leaflet_id;
      });

      layers = layers.concat(redrawnLines);

      layers.forEach(id => {
        let line = context.state.lines.find(l => {
          return l.leafletid == id;
        });

        if (line) {
          let coordinates = payload.edited._layers[id]._latlngs.map(latlng => {
            let c = [];
            c[0] = latlng.lng;
            c[1] = latlng.lat;

            return c;
          });
          //line.points = payload._layers[id]._latlngs;
          line.geometry = {
            coordinates: coordinates
          };

          updated.push(line);
        }
      });

      if (updated.length > 0) {
        //axios.put(APIURL + 'routelines/update', updated)
        return axios
          .put(APIURL + 'routelines/update', updated)
          .then(() => {
            //console.log("updateMovedLines",res.data);
            //context.dispatch('updateGuideLayer')

            //console.log("###### updateMovedLines", res.data)

            //window.vm.$emit('drawedited');
            return Promise.resolve(true);
          })
          .catch(() => {
            //console.log(err);
            //window.vm.$emit('drawedited');
            return Promise.reject();
          });
      } else {
        //window.vm.$emit('drawedited');
        return Promise.resolve(true);
      }
    },

    /*updateMovedLines(context, payload)
		{
			let updated = []
			let layers = Object.keys(payload.edited._layers).map((id) => {
				return id;
			})

			let redrawnLines = context.state.redrawnLines.map((rdl) => {
				payload.edited._layers[rdl._leaflet_id] = rdl; 
				return rdl._leaflet_id;
			})

			layers = layers.concat(redrawnLines);
			
			

			layers.forEach((id) => {
				let line = context.state.lines.find((l) => {

					return l.leafletid == id;
				});

				
				
				if(line)
				{	
					
					let coordinates = payload.edited._layers[id]._latlngs.map((latlng) => {
						let c = [];
						c[0] = latlng.lng;
						c[1] = latlng.lat;

						return c;
					})
					//line.points = payload._layers[id]._latlngs;
					line.geometry = {
						coordinates: coordinates
					}
					
					updated.push(line);
				}

			});

			if(updated.length > 0)
			{


			
				axios.put(APIURL + 'routelines/update', updated)
				.then((res) => {
					//console.log("updateMovedLines",res.data);
					//context.dispatch('updateGuideLayer')

					//console.log("###### updateMovedLines", res.data)

					window.vm.$emit('drawedited');

				})
				.catch((err) => {
					console.log(err);
					window.vm.$emit('drawedited');
				})
			} else {
				window.vm.$emit('drawedited');
			} 
		},*/

    setLineLeafletId(context, payload) {
      let i = context.state.lines.findIndex(l => {
        return l._id == payload.l._id;
      });

      if (i > -1) {
        context.commit('setLineLeafletId', {
          i: i,
          polyline: payload.polyline
        });
      }
    },

    lines(context, payload) {
      if (typeof context.rootGetters['routes/route'] !== 'undefined') {
        let name = context.rootGetters['routes/route'].name;
        return axios.get(`${APIURL}routelines/${name}`);
      }

      return Promise.reject('Not found');
    },
    // TODO: check if routeline is already saved with
    // this routename

    // TODO: make sure that new coordinates get saved into db because we can see them changing in console.log

    insertLineAutomatically(context, payload) {
      let newMarker = payload.newMarker;
      let secondToLastMarker = payload.secondToLast;

      let nmLatlng = {
        lat: newMarker.geometry.coordinates[1],
        lng: newMarker.geometry.coordinates[0]
      };

      let stlLatlng = {
        lat: secondToLastMarker.geometry.coordinates[1],
        lng: secondToLastMarker.geometry.coordinates[0]
      };

      let layer = {
        _latlngs: [nmLatlng, stlLatlng]
      };

      context.dispatch('insert', { layer: layer, closestMarkers: [] });
    },

    insert(context, payload) {
      let layer = payload.layer;
      let latlngs = layer._latlngs;
      let closestMarkers = payload.closestMarkers;
      //let newLatlng = []

      closestMarkers.forEach((cm, cmi) => {
        //newLatlng.push([])
        if (cm.valid === true) {
          layer._latlngs[cmi].lat = cm.closest.r.geometry.coordinates[1];
          layer._latlngs[cmi].lng = cm.closest.r.geometry.coordinates[0];
        }
      });

      //layer._latlngs = latlngs;

      //console.log("layer::latlngs after", layer._latlngs, payload.closestMarkers)

      axios
        .post(APIURL + 'routelines/store', {
          properties: {
            name: context.rootGetters['routes/route'].name,
            description: 'path'
          },

          geometries: layer._latlngs
          //geometries: newLatlng
        })
        .then(storeRes => {
          let points = storeRes.data.geometry.coordinates.map(c => {
            let coordinates = {
              lat: c[1],
              lng: c[0]
            };

            return coordinates;
          });

          storeRes.data.points = points;

          context.commit('addLine', {
            res: storeRes.data,
            leafletid: layer._leaflet_id
          });
          context.dispatch('status/updateResources', 'routelines', {
            root: true
          });
        })
        .catch(err => {
          console.log('storeRes - err ', err);
        });
    }
  },

  mutations: {
    setDrawLineAutomatically(state, payload) {
      state.drawLineAutomatically = payload;
    },

    addRedrawnLine(state, payload) {
      let redrawnLines = state.redrawnLines;
      redrawnLines.push(payload);
      state.redrawnLines = [];
      state.redrawnLines = redrawnLines;
    },

    flushRedrawnLines(state, payload) {
      state.redrawnLines = [];
    },

    updateGuideLayer(state, payload) {
      let lines = state.lines;

      let features = lines.map(l => {
        let coordinates = l.points.map(p => {
          return [p.lng, p.lat];
        });

        let geometry = {
          type: 'LineString',
          coordinates: coordinates
        };
        return {
          type: 'Feature',
          properties: l.properties,
          geometry: geometry
        };
      });

      //console.log("######### guideLayer", features)

      let guideLayer = L.geoJson({
        type: 'FeatureCollection',
        features: features
      });

      payload.forEach(marker => {
        if (typeof marker.snapediting !== 'undefined') {
          marker.snapediting.addGuideLayer(guideLayer);
        }
      });

      state.guideLayer = guideLayer;
    },

    setAttachMarkerToNode(state, payload) {
      state.attachMarkerToNode = payload;
    },

    updateLinesPosAfterMarkerRemove(state, payload) {
      let lines = state.lines;
      Object.keys(payload).forEach(leafletid => {
        let i = lines.findIndex(l => {
          return l.leafletid == leafletid;
        });

        if (i > -1) {
          lines[i].points = payload[leafletid].newCoords;
        }
      });

      state.lines = [];

      state.lines = lines;
    },

    /*addLeafletLine(state, payload)
		{
			let leafletLines = state.leafletLines;

			leafletLines[payload._leaflet_id] = payload
		}, */

    /*setLeafletLines(state, payload)
		{
			state.leafletLines = payload
		},*/

    setClosestLines(state, payload) {
      state.closestLines = payload;
    },

    mapLinesToPolylines(state, payload) {
      state.lines = payload;
    },

    /*update(state, payload)
		{

			//let lines = state.lines;
			let lines = state.lines;
			lines[payload.i].points = payload.points;
			state.lines = lines;

		}, */

    destroy(state, payload) {
      let lines = state.lines;
      payload.forEach(id => {
        let i = lines.findIndex(l => {
          return l._id == id;
        });

        if (i > -1) {
          lines.splice(i, 1);
        }
      });

      state.lines = lines;
    },

    setLineLeafletId(state, payload) {
      let lines = state.lines;
      lines[payload.i].leafletid = payload.polyline._leaflet_id;
      state.lines = lines;
    },

    addLine(state, payload) {
      //console.log("addLine", payload)
      let lines = state.lines;
      lines.push({
        _id: payload.res._id,
        leafletid: payload.leafletid,
        points: payload.res.points,
        properties: {
          name: payload.res.properties.name
        }
      });

      state.lines = lines;
      //console.log("addLine", lines)
    },

    lines(state, payload) {
      let guideLayer = new L.geoJson(payload);
      state.guideLayer = {};
      state.guideLayer = guideLayer;

      //console.log("########### guideLayer set");

      let lines = [];
      payload.features.forEach((l, i) => {
        let data = {
          properties: {
            name: l.properties.name,
            removed: l.properties.removed || false
          },
          _id: l._id,
          points: []
        };

        lines.push(data);

        l.geometry.coordinates.forEach(c => {
          lines[i].points.push({
            lat: c[1],
            lng: c[0]
          });
        });
      });

      state.lines = lines;

      // guide layers
    }
  },

  getters: {
    drawLineAutomatically(state) {
      return state.drawLineAutomatically;
    },

    closestLines(state) {
      return state.closestLines;
    },

    lines(state) {
      return state.lines;
    },

    guideLayer(state) {
      return state.guideLayer;
    },

    attachMarkerToNode(state) {
      return state.attachMarkerToNode;
    }
  }
};
